// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Container */
.nfc-page-container {
  padding: 30px 40px;
  background: #f8f9fa;
  min-height: 100vh;
  font-family: "Inter", sans-serif;
  color: #1e293b;
}

/* Header */
.nfc-header h2 {
  font-size: 28px;
  font-weight: 700;
  margin-bottom: 8px;
  color: #111733;
}

.nfc-header h4 {
  font-size: 16px;
  font-weight: 500;
  color: #334155;
  margin-bottom: 24px;
}

/* Grid for analysis cards */
.analysis-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 24px;
}

/* Individual Analysis Card */
.analysis-card {
  background: linear-gradient(180deg, #ffffff, #f1f5f9);
  border-radius: 14px;
  padding: 20px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
  display: flex;
  flex-direction: column;
  gap: 16px;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.analysis-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.15);
}

/* Analysis Type Label */
.analysis-type {
  font-weight: 700;
  font-size: 16px;
  color: #111733;
}

/* Pipeline Buttons Container */
.pipeline-buttons {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

/* Pipeline Buttons */
.pipeline-btn {
  background: #2563eb;
  color: #ffffff;
  border: none;
  border-radius: 10px;
  padding: 8px 12px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  text-align: left;
  transition: all 0.2s ease;
  box-shadow: 0 4px 12px rgba(37, 99, 235, 0.25);
}

.pipeline-btn:hover {
  background: #1d4ed8;
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(37, 99, 235, 0.35);
}

/* Responsive adjustments */
@media (max-width: 1024px) {
  .analysis-grid {
    grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  }
}

@media (max-width: 640px) {
  .nfc-page-container {
    padding: 20px 16px;
  }

  .pipeline-btn {
    width: 100%;
  }
}

.coming-soon-text {
    padding: 12px;
    font-size: 14px;
    font-weight: bold;
    color: #777;
    text-align: center;
    opacity: 0.8;
}
`, "",{"version":3,"sources":["webpack://./src/css/NfcPage.css"],"names":[],"mappings":"AAAA,cAAc;AACd;EACE,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,gCAAgC;EAChC,cAAc;AAChB;;AAEA,WAAW;AACX;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA,6BAA6B;AAC7B;EACE,qDAAqD;EACrD,mBAAmB;EACnB,aAAa;EACb,0CAA0C;EAC1C,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,qDAAqD;AACvD;;AAEA;EACE,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA,wBAAwB;AACxB;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,qBAAqB;AACrB;EACE,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA,2BAA2B;AAC3B;EACE;IACE,2DAA2D;EAC7D;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;IACI,aAAa;IACb,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,kBAAkB;IAClB,YAAY;AAChB","sourcesContent":["/* Container */\n.nfc-page-container {\n  padding: 30px 40px;\n  background: #f8f9fa;\n  min-height: 100vh;\n  font-family: \"Inter\", sans-serif;\n  color: #1e293b;\n}\n\n/* Header */\n.nfc-header h2 {\n  font-size: 28px;\n  font-weight: 700;\n  margin-bottom: 8px;\n  color: #111733;\n}\n\n.nfc-header h4 {\n  font-size: 16px;\n  font-weight: 500;\n  color: #334155;\n  margin-bottom: 24px;\n}\n\n/* Grid for analysis cards */\n.analysis-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\n  gap: 24px;\n}\n\n/* Individual Analysis Card */\n.analysis-card {\n  background: linear-gradient(180deg, #ffffff, #f1f5f9);\n  border-radius: 14px;\n  padding: 20px;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  transition: transform 0.2s ease, box-shadow 0.2s ease;\n}\n\n.analysis-card:hover {\n  transform: translateY(-4px);\n  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.15);\n}\n\n/* Analysis Type Label */\n.analysis-type {\n  font-weight: 700;\n  font-size: 16px;\n  color: #111733;\n}\n\n/* Pipeline Buttons Container */\n.pipeline-buttons {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n/* Pipeline Buttons */\n.pipeline-btn {\n  background: #2563eb;\n  color: #ffffff;\n  border: none;\n  border-radius: 10px;\n  padding: 8px 12px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 500;\n  text-align: left;\n  transition: all 0.2s ease;\n  box-shadow: 0 4px 12px rgba(37, 99, 235, 0.25);\n}\n\n.pipeline-btn:hover {\n  background: #1d4ed8;\n  transform: translateY(-2px);\n  box-shadow: 0 6px 16px rgba(37, 99, 235, 0.35);\n}\n\n/* Responsive adjustments */\n@media (max-width: 1024px) {\n  .analysis-grid {\n    grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));\n  }\n}\n\n@media (max-width: 640px) {\n  .nfc-page-container {\n    padding: 20px 16px;\n  }\n\n  .pipeline-btn {\n    width: 100%;\n  }\n}\n\n.coming-soon-text {\n    padding: 12px;\n    font-size: 14px;\n    font-weight: bold;\n    color: #777;\n    text-align: center;\n    opacity: 0.8;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
